import React from 'react'
import styled from 'styled-components'
import shortid from 'shortid'

import media from '../../../styles/media'

import group21 from '../../../static/images/stories/group-21.png'

const StoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const StoriesTitle = styled.h3`
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  color: #3c4252;
  margin-bottom: 0;
`

const StoriesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  box-shadow: 0 12px 14px 0 rgba(64, 180, 228, 0.14);
  ${media.md`  
    margin: 25px 0;
    grid-template-columns: 1fr 1fr;
    display: grid;
  `};
`

const TextWrapper = styled.div`
  padding: 50px;
  background-color: #ffffff;
  border: solid 1px rgba(64, 180, 228, 0.15);
  height: 100%;
`
const TextTitle = styled.p`
  font-size: 25px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.92;
  letter-spacing: normal;
  text-align: left;
  color: #40b4e4;
`

const SubTitle = styled.p`
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #dbdbdb;
`

const Introduction = styled.p`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #3c4252;
`

const TitleDetail = styled.p`
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #3c4252;
`

const Detail = styled.p`
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #3c4252;
`

const ImgClass = styled.img`
  max-width: 100%;
  height: auto;
`

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Group1 = styled.div`
  display: -webkit-flex; /* Safari */
  -webkit-align-items: center; /* Safari 7.0+ */
  display: flex;
  align-items: center;
  -webkit-box-ordinal-group: 1;
  -moz-box-ordinal-group: 1;
  -ms-flex-order: 1;
  -webkit-order: 1;
  order: 1;
  background: ${props => props.background};

  ${media.md`
  -webkit-box-ordinal-group: 2;
  -moz-box-ordinal-group: 2;
  -ms-flex-order: 2;
  -webkit-order: 2;
  order: 2;
  `};
`

const Group2 = styled.div`
  display: -webkit-flex; /* Safari */
  -webkit-align-items: center; /* Safari 7.0+ */
  display: flex;
  align-items: center;
  -webkit-box-ordinal-group: 2;
  -moz-box-ordinal-group: 2;
  -ms-flex-order: 2;
  -webkit-order: 2;
  order: 2;
  ${media.md`
  -webkit-box-ordinal-group: 1;
  -moz-box-ordinal-group: 1;
  -ms-flex-order: 1;
  -webkit-order: 1;
  order: 1;
  `};
`

const Stories = props => {
  const { stories } = props
  const successStories = stories.items.map(story => (
    <StoriesWrapper key={shortid.generate()}>
      <Group2>
        <TextWrapper>
          <SubTitle>{story.subtitle}</SubTitle>
          <TextTitle>{story.title}</TextTitle>
          <Introduction>{story.introduction}</Introduction>
          <TitleDetail>{story.detailtitle}</TitleDetail>
          <Detail dangerouslySetInnerHTML={{ __html: story.detail }} />
        </TextWrapper>
      </Group2>
      <Group1 background={story.background}>
        <ImageWrapper className="mx-auto">
          <ImgClass className="img-fluid" src={group21} />
        </ImageWrapper>
      </Group1>
    </StoriesWrapper>
  ))
  return (
    <StoriesContainer {...props}>
      {stories && stories.title != '' ? (
        <div>
          <StoriesTitle>{stories.title}</StoriesTitle>
          {successStories}
        </div>
      ) : (
        ''
      )}
    </StoriesContainer>
  )
}

export default Stories



// WEBPACK FOOTER //
// ./src/components/section/stories/stories.js